import { render, staticRenderFns } from "./actionsParamsForm.vue?vue&type=template&id=47bb2f80"
import script from "./actionsParamsForm.vue?vue&type=script&lang=js"
export * from "./actionsParamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports